import {ClientModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: ClientModel = {
  id: '',
  nombre: '',
  companiaId: '',
  empresaId: '',
  ...aditionalValues,
}
